import React from "react";
import { makeStyles } from "@material-ui/core";

import AppLayout from "../AppLayout";
import MapContainer from "./MapContainer";

const useStyles = makeStyles({
  content: {
    height: "80vh",
    minHeight: 480,
    display: "flex",
    flexDirection: "column"
  }
});

const MapPageContainer = () => {
  const classes = useStyles();

  return (
    <AppLayout selectedMenu="map">
      <div className={classes.content}>
        <MapContainer />
      </div>
    </AppLayout>
  );
};

export default MapPageContainer;
